module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAMhJREFUOE/Nks0JwkAQhWfIHsWLDWgTHkJ6yC3srpASbEF7SAsLk+RuAVpBLEIr0EtgeRJQ0fxAIJfsbXffN7x5M0wTDk9gaQZwnueOiHYj2si01vtG97XtnFsqpSoi2gwVAHAKgiBOksT/wc1FREJmPhOR6ilQ1XUdpWn6/Px1AiuK4gDg2IJvALbGmPvvewcuyzLw3l+YOXwLH0QUaa2vbTe9oxKRNTM3/S8AxMaYU18Og3MWEQtgZa3NhgKcwZKMWI6OZJLtFzijOxAmPBI+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/images/arrow.png
// module id = h+Rv
// module chunks = 1